import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { sendForm } from 'shared/common/thunks';

import { TFormStatus, EStatus } from 'shared/common/types/form/form';

const initialState: TFormStatus = { status: EStatus.Initial };

/* istanbul ignore next */
const formSlice = createSlice({
  extraReducers(builder) {
    builder
      .addCase(sendForm.pending, state => {
        state.status = EStatus.Loading;
      })
      .addCase(sendForm.fulfilled, state => {
        state.status = EStatus.Succeed;
      })
      .addCase(sendForm.rejected, state => {
        state.status = EStatus.Failed;
      });
  },
  initialState,
  name: 'formStatus',
  reducers: {
    setStatus: (state, action: PayloadAction<EStatus>) => {
      state.status = action.payload;
    },
  },
});

export const {
  reducer: formReducer,
  actions: { setStatus },
} = formSlice;
